<div class="finance-page">

  <div class="header">

    <h1>📈 Finance Analytics</h1>

    <p>
      Revenue, profit and business performance overview
    </p>

  </div>

  <div class="stats">

    <div class="card revenue">

      <h3>Total Revenue</h3>

      <h2>৳ {{ revenue | number }}</h2>

      <span>Completed sales earnings</span>

    </div>

    <div class="card profit">

      <h3>Total Profit</h3>

      <h2>৳ {{ profit | number }}</h2>

      <span>Net business profit</span>

    </div>

    <div class="card invest">

      <h3>Total Investment</h3>

      <h2>৳ {{ invest | number }}</h2>

      <span>Current inventory investment</span>

    </div>

  </div>

  <div class="report">

    <h2>📊 Business Summary</h2>

    <div class="report-box">

      <p>
        Your store generated
        <b>৳ {{ revenue | number }}</b>
        in total sales revenue.
      </p>

      <p>
        Current net profit:
        <b>৳ {{ profit | number }}</b>
      </p>

      <p>
        Total inventory investment:
        <b>৳ {{ invest | number }}</b>
      </p>

    </div>

  </div>

</div>